"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var BuildingremotelySvg = function BuildingremotelySvg(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    height: "401px",
    width: "284px",
    version: "1.1",
    viewBox: "0 0 284 401",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, "Untitled"), /*#__PURE__*/_react.default.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "T-icon-BR",
    fill: "#9B9BE8",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "Path_1619",
    d: "M88.1,0 L24.1,0 C10.8,0 0.1,10.7 0.1,24 L0.1,376 C0.1,389.3 10.8,400 24.1,400 L24.1,400 L88.1,400 C101.4,400 112.1,389.3 112.1,376 L112.1,376 L112.1,24 C112.1,10.7 101.3,0 88.1,0 Z M96.1,376 C96.1,380.4 92.5,384 88.1,384 C88.1,384 88.1,384 88.1,384 L24.1,384 C19.7,384 16.1,380.4 16.1,376 L16.1,376 L16.1,352 L32.1,352 C36.5,352 40.1,348.4 40.1,344 C40.1,339.6 36.5,336 32.1,336 L16.1,336 L16.1,304 L32.1,304 C36.5,304 40.1,300.4 40.1,296 C40.1,291.6 36.5,288 32.1,288 L16.1,288 L16.1,256 L32.1,256 C36.5,256 40.1,252.4 40.1,248 C40.1,243.6 36.5,240 32.1,240 L16.1,240 L16.1,208 L32.1,208 C36.5,208.1 40.2,204.6 40.3,200.2 C40.4,195.8 36.9,192.1 32.5,192 C32.4,192 32.2,192 32.1,192 L16.1,192 L16.1,160 L32.1,160 C36.5,160 40.1,156.4 40.1,152 C40.1,147.6 36.5,144 32.1,144 L16.1,144 L16.1,112 L32.1,112 C36.5,112 40.1,108.4 40.1,104 C40.1,99.6 36.5,96 32.1,96 L16.1,96 L16.1,64 L32.1,64 C36.5,64 40.1,60.4 40.1,56 C40.1,51.6 36.5,48 32.1,48 L16.1,48 L16.1,24 C16.1,19.6 19.7,16 24.1,16 L24.1,16 L88.1,16 C92.5,16 96.1,19.6 96.1,24 L96.1,376 L96.1,376 Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Path_1620",
    d: "M227.9,0 C197,0 172,25.1 171.9,56 L171.9,344 C171.9,346.1 172.7,348.2 174.2,349.7 L222.2,397.7 C225.3,400.8 230.4,400.8 233.5,397.7 C233.5,397.7 233.5,397.7 233.5,397.7 L281.5,349.7 C283,348.2 283.800298,346.2 283.800298,344 L283.800298,56 C283.9,25.1 258.8,0 227.9,0 Z M227.9,380.7 L191.2,344 L264.6,344 L227.9,380.7 Z M267.9,328 L235.9,328 L235.9,200 C236,195.6 232.5,191.9 228.1,191.8 C223.7,191.7 220,195.2 219.9,199.6 C219.9,199.7 219.9,199.9 219.9,200 L219.9,328 L187.9,328 L187.9,144 L267.9,144 L267.9,328 Z M267.9,128 L187.9,128 L187.9,96 L267.9,96 L267.9,128 Z M267.9,80 L187.9,80 L187.9,56 C187.9,33.9 205.8,16 227.9,16 C250,16 267.9,33.9 267.9,56 L267.9,80 Z"
  }))));
};

var _default = BuildingremotelySvg;
exports.default = _default;